import { createSlice } from '@reduxjs/toolkit'
import { fetchMonthlyEngineStats } from './adminAPI'
import { buildExtraReducers, dismissErrorReducer } from './adminReducer'
import type { AdminState } from './types'

const initialState: AdminState = {
  fetching: false,
  errors: {}
}

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    dismissError: dismissErrorReducer
  },
  extraReducers: (builder) => buildExtraReducers(builder, { fetchMonthlyEngineStats })
})

export const { dismissError } = adminSlice.actions
